import React from 'react';

import { Box, Typography } from '@mui/material';
import { IExistingBroadcastGroupLead } from '@pharmaplan/common';

import strings from '../../../../localization';
import styles from './styles';

export const getBroadcastGroupLeadsSuccessMessage = (
  existingLeads: Array<IExistingBroadcastGroupLead>,
  selectedUserCount: number,
) => {
  if (!existingLeads.length) {
    return strings.actionCompletedSuccessfully;
  }

  if (existingLeads.length === selectedUserCount) {
    return strings.allBroadcastGroupMembersLinkedToCampaign;
  }

  return (
    <>
      <Typography sx={styles.successMessage}>
        {strings.actionCompletedSuccessfully}
      </Typography>
      <br />
      <Typography sx={styles.successMessage}>
        {strings.broadcastLeadInvitesNotSent}
      </Typography>
      <Box component="span" sx={styles.list}>
        {existingLeads.map((lead, index) =>
          (
            <Typography
              key={`${lead.email}-${lead.campaignName}`}
              sx={styles.listItems}
            >
              {`${index + 1}. ${lead.name}`}
            </Typography>
          ))}
      </Box>
    </>
  );
};
